import axios from "axios";
import { endLoader, startLoader } from "@/pages/LoaderWrapper";
const apiKey = import.meta.env.VITE_API || "http://16.170.162.41/api/v0/";
// const apiKey = import.meta.env.VITE_API || "https://inforens-api.onrender.com/api/v0/";
// const apiKey = import.meta.env.VITE_API || "https://cors-anywhere.herokuapp.com/http://16.170.162.41/api/v0/";

const axiosInstance = axios.create({
  baseURL: `${apiKey}/api/v0/`,
});

let requestCount = 0;

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // TO start top loader
    if (!config?.bypassAuth && !config?.byPassLoader) {
      if (requestCount === 0) {
        // First request, start the loader
        startLoader();
      }
      requestCount++;
    }

    const token = localStorage.getItem("token");
    if (token && !config?.bypassAuth) {
      config.headers["Authorization"] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // TO stop top loader
    requestCount--;

    if (requestCount === 0) {
      // Last request, stop the loader
      endLoader();
    }

    // You can add any logic here for successful responses
    return response;
  },
  (error) => {
    // TO stop top loader
    requestCount--;

    if (requestCount === 0) {
      // Last request, stop the loader
      endLoader();
    }
    // You can add error handling logic here
    return Promise.reject(error);
  }
);

export default axiosInstance;
